import React from "react";
import { connect } from "react-redux";
import ScrollArea from "react-scrollbar";
import styled from "styled-components";

import { Show, getScreenLayout } from "../../lib/utils";
import { Messages } from "./Messages";
import { SlackTypingAnimation } from "../SlackController/SlackController";
import HistoryHandler from "../HistoryHandler";
import DumbTextInput from "../InputField/DumbTextInput";
import SmartTextInput from "../InputField/SmartTextInput";
import ContactWarning from "./ContactWarning";
import { saveScrollAreaRef } from "./actions";
import ConfirmSelectionButton from "../ConfirmSelectionButton";
import {
  getChatMode,
  getShouldShowConfirmSelection,
  getShouldShowDatePicker,
  getShouldShowTextInput,
} from "../../store";
import { getWorkWithHistory } from "../messages/selectors";
import { getIsIAactive, getShowIAQuickActions } from "../InstantAnswers/selectors";
import FamilyAssetsCalendar from "../Calendar/Calendar";
import { sendMessage as iaSendMessage } from "../InstantAnswers/messaging";
import { QuickActions } from "../InstantAnswers/QuickActions";
import { financialChatActivated, ScreenSize } from "../../lib/constants";
import { ChatModes } from "../../lib/types";

/**
 * Render chat's scroll area - everything that is scrolled.
 * (And everything that is fixed below the scroll area as well).
 * Finally handles the rendering of all the messages and input fields and buttons etc.
 *
 * Failed to make it a function component - `sendIaMessage` and `saveIaInput` have to be a class methods,
 * otherwise the input fields get rerendered when new message arrives.
 */
class ChatContent extends React.Component {
  sendIaMessage = (text) => {
    const { dispatch } = this.props;
    dispatch(iaSendMessage(text));
  };

  saveIaInput = (ref) => {
    window.famIAinput = ref;
  };

  /**
   * TODO: Move this away from inline styles.
   */
  getScrollMaxHeight = () => {
    const { showTextInput, isIaActive, showConfirmSelectionButton, chatMode } = this.props;

    if (isIaActive && chatMode === ChatModes.open && getScreenLayout() === "desktop") {
      return "unset";
    }

    if (window.innerWidth <= ScreenSize.mobile || financialChatActivated) {
      return "initial";
    }
    if (showTextInput || showConfirmSelectionButton) {
      return "478px";
    }
    return "560px";
  };

  render() {
    const {
      editingMode,
      isIaActive,
      showIAQuickActions,
      showDatePicker,
      showTextInput,
      showConfirmSelectionButton,
    } = this.props;

    return (
      <ChatContentDiv>
        <StyledScrollArea
          className={editingMode ? "editing" : ""}
          style={{
            maxHeight: this.getScrollMaxHeight(),
          }}
          smoothScrolling
          stopScrollPropagation
          ref={(scrollArea) => saveScrollAreaRef(scrollArea)}
        >
          <Show when={!editingMode && !isIaActive}>
            <HistoryHandler />
          </Show>

          <Messages />

          <Show when={showDatePicker && !isIaActive}>
            <FamilyAssetsCalendar />
          </Show>

          <SlackTypingAnimation />
        </StyledScrollArea>

        <Show when={isIaActive}>
          <Show when={showIAQuickActions}>
            <QuickActions />
          </Show>
          <DumbTextInput onRef={this.saveIaInput} onSubmit={this.sendIaMessage} />
        </Show>

        <Show when={!isIaActive && showTextInput}>
          <SmartTextInput />
        </Show>

        <ContactWarning />

        <Show when={showConfirmSelectionButton && !isIaActive}>
          <ConfirmSelectionButton />
        </Show>
      </ChatContentDiv>
    );
  }
}

const ChatContentDiv = styled.div`
  width: 100%;
  height: 100%;
  align-self: flex-end;
  display: flex;
  flex-direction: column;

  font-size: ${(props) => props.theme.fontSize || "13px"};
  color: ${(props) => props.theme.textColor || "#222"};
  font-family: ${(props) => props.theme.fontFamily || "arial"};

  * {
    font-family: ${(props) => props.theme.fontFamily || "arial"};
  }
`;

const StyledScrollArea = styled(ScrollArea)`
  height: 100%;
  width: 100%;
  align-self: flex-end;
  padding: 0 20px 20px;

  &.editing {
    padding: 0 20px;
  }

  .scrollarea-content {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    min-height: 100%;
    display: flex;
    overflow: visible;
  }
`;

function mapStateToProps(state) {
  return {
    showTextInput: getShouldShowTextInput(state),
    showDatePicker: getShouldShowDatePicker(state),
    showConfirmSelectionButton: getShouldShowConfirmSelection(state),
    editingMode: getWorkWithHistory(state),
    isIaActive: getIsIAactive(state),
    showIAQuickActions: getShowIAQuickActions(state),
    chatMode: getChatMode(state),
  };
}

export default connect(mapStateToProps)(ChatContent);
